var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"gradient-divider"}),_c('main',{staticClass:"flex-fill"},[_c('router-view')],1),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }